// extracted by mini-css-extract-plugin
module.exports = {"spinning":"loader-button-module--spinning--2TffH","spin":"loader-button-module--spin--1gb-O"};